import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Swal from "sweetalert2";
import { useState } from "react";
import { setAccessToken, setRefreshToken } from "../../../../storage/storage";
import { ButtonLoader2 } from "../../../../components/shared/ButtonLoaders";
import useCurrentUser from "../../../../services/useCurrentUser";

/************************************* Google ************************************/
export function SocialLogin() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const { getCurrentUser } = useCurrentUser();

  const Login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setLoading(true);
      axios
        .post(`${BASE_URL}/api/login-with-google/`, {
          token: codeResponse.access_token,
        })
        .then((response) => {
          setLoading(false);
          setAccessToken(response.data.access);
          setRefreshToken(response.data.refresh);
          window.location.href = "/";
          getCurrentUser(response.data.access);
        })
        .catch((error) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            text:
              error?.response?.data?.message ||
              "Oops! Something went wrong on our end. Please give us a moment to fix it. Feel free to try again later",
            customClass: {
              confirmButton: "custom-red-button",
            },
          });
        });
    },
    onError: (error) => {
      Swal.fire({
        icon: "error",
        text: "Oops! Something went wrong on our end. Please give us a moment to fix it. Feel free to try again later",
        customClass: {
          confirmButton: "custom-red-button",
        },
      });
    },
  });

  return (
    <div className="flex items-center justify-center gap-2">
      <button onClick={() => Login()} className="">
        {loading ? (
          <ButtonLoader2 />
        ) : (
          <img src="/assets/icons/google.png" alt="" />
        )}
      </button>
      <button onClick={() => Login()} className="">
        {loading ? (
          <ButtonLoader2 />
        ) : (
          <img src="/assets/icons/facebook.png" alt="" />
        )}
      </button>
      <button onClick={() => Login()} className="">
        {loading ? (
          <ButtonLoader2 />
        ) : (
          <img src="/assets/icons/apple.png" alt="" />
        )}
      </button>
    </div>
  );
}
